@if (title) {
    <div class="label">
        <div class="label-title">
            {{ title }}
        </div>
    </div>
}
@if (icon) {
    <div class="media">
        <ng-content select="fui-icon"></ng-content>
    </div>
}
